import { SupplierSubscriptionPlan } from '../../types/SupplierGroupSubscriptionMessage';
import { formatDate } from '../common/helpers/formatDate.helper';
import { translate } from '../common/helpers/translate.helper';

import { hasSupplierSubscriptionPlanSpecialOffer } from './hasSupplierSubscriptionPlanSpecialOffer';
import { useSupplierSubscriptionPlanCatalog } from './useSupplierSubscriptionPlanCatalog';

export const useSupplierSubscriptionPlanPromotion = (enabled: boolean) => {
    const catalog = useSupplierSubscriptionPlanCatalog(enabled, false);
    const professional = catalog.data?.plans.find((plan) => plan.plan === SupplierSubscriptionPlan.PROFESSIONAL);
    const heading = translate('supplierSubscriptionPlans.professionalUpgrade');
    const description = translate('supplierSubscriptionPlans.professionalDescription');
    const isSpecialOfferActive = professional !== undefined && hasSupplierSubscriptionPlanSpecialOffer(professional);
    const promotion = { heading, description, isSpecialOfferActive };
    if (!professional?.annualPrice || professional.annualPrice.value <= 0) {
        return promotion;
    }
    if (
        !isSpecialOfferActive ||
        professional.annualSpecialOfferPrice === undefined ||
        professional.specialOfferValidUntil === undefined
    ) {
        return promotion;
    }
    const savings = Math.round((1 - professional.annualSpecialOfferPrice.value / professional.annualPrice.value) * 100);
    if (savings <= 0) {
        return promotion;
    }
    return {
        ...promotion,
        description: translate('supplierSubscriptionPlans.upgradeSavings', {
            percentage: String(savings),
            date: formatDate({ date: professional.specialOfferValidUntil, timeZone: 'UTC' }),
        }),
    };
};
